import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";

import { setCSRFToken } from "../utils/auth";

const apiUrl = process.env.REACT_APP_API_URL;

function getCSRFToken() {
  const name = "csrftoken";
  const value = document.cookie.split("; ").find(row => row.startsWith(name + "="));
  return value ? value.split("=")[1] : "";
}

const PrivateRoute = ({ component: Component }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);  // null = loading state
  
  const csrf_token = getCSRFToken()
  console.log(`CSRFTOKEN: ${csrf_token}`);
  // const isAuthenticated = document.cookie.includes("sessionid"); // Example for checking session cookie
  useEffect(() => {
    console.log(`Getting user info, token ${csrf_token}`);
    axios.get(`${apiUrl}/ai/api/user-info/`, { 
      withCredentials: true, 
      headers: {
        'X-CSRFToken': csrf_token,  
      } 
    })
      .then(response => {
        console.log(`Private Route response: ${JSON.stringify(response.data)}`);
        if (response.data.authenticated) {
          console.log(`authenticated!`);
          setIsAuthenticated(true);
          setCSRFToken(response.data.csrfToken); 
        } else {
          setIsAuthenticated(false);
        }
      })
      .catch(
        (error) =>  { 
          console.log(`private route Error: ${error}`);
          setIsAuthenticated(false);
        }        
      );
  }, [csrf_token]);

  const currentUrl = `${window.location.origin}${location.pathname}`;
  console.log(`privateRoute: currentURL ${currentUrl}, cookie: ${document.cookie}, authenticated: ${isAuthenticated}`);
  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Show a loading state while checking authentication
  }
  return isAuthenticated ? (
    <Component />
  ) : (
    <Navigate to={`/login?next=${encodeURIComponent(currentUrl)}`} replace />
  );
};

export default PrivateRoute;